import { Component } from '@angular/core';

@Component({
  selector: 'lib-feature-crm-data-access',
  imports: [],
  templateUrl: './feature-crm-data-access.html',
  styleUrl: './feature-crm-data-access.css',
})
export class FeatureCrmDataAccess {}
